module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _vm._v("Maps")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_chapter2#map1"
    }
  }, [_vm._v(" 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_chapter2#map1"
    }
  }, [_vm._v("Situation at Taukkyon, night of 7th/8th March")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The longest retreat: the route from Rangoon to Imphal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Actions fought in the Prome area")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The battle of Yenaungyaung")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter4#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter4#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First and Second Arakan Campaigns")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter6#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter6#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Imphal Plain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter6#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter6#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The battle for Nunshigum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter7#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter7#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kohima: actions fought by 149 Regiment RAC")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter8#map9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter8#map9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Corps’ operations aimed at Meiktila")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter9#map10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter9#map10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The capture of Meiktila")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#map11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#map11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The battle of the Irrawaddy Bend: 33 Corps Divisional bridgeheads")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#map12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#map12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arakan – final offensive, 1944–45")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#map13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#map13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The advance on Rangoon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#map14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#map14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Division breaks the enemy front at Pyawbwe")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359f034d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_maps.vue
// module id = 75
// module chunks = 0